// Côté DONATEUR : son paiement (popup carte) est confirmé → fête sur place, sans quitter l'écran (profil, direct…).
// `id` = intention Stripe (pi_…) : la même confirmation peut arriver deux fois (relecture du statut + notification
// « Merci » en temps réel) → la fête ne se joue qu'une fois par paiement. `body` = phrase « Merci » du bénéficiaire.
export const DONATION_SENT_EVENT = "yalola:donation-sent";
export const celebrateDonationSent = (amount, currency, id, body) => {
  window.dispatchEvent(new CustomEvent(DONATION_SENT_EVENT, { detail: { amount, currency, id: id || `${Date.now()}`, body: body || null } }));
};

// Phrase « Merci » standard selon le rôle du bénéficiaire (prédicateur / artiste-influenceur) — modifiable par lui.
export const DONOR_THANKS_DEFAULTS = {
  "donate.sent_body": "Que Dieu te bénisse !",
  "donate.sent_body_creator": "Merci du fond du cœur pour ton soutien !",
};
export const donorThanksKey = (role) => (role === "preacher" ? "donate.sent_body" : "donate.sent_body_creator");
export const donorThanksBody = (receiver, t) => {
  const custom = (receiver?.donor_thanks_message || "").trim();
  if (custom) return custom;
  const key = donorThanksKey(receiver?.role);
  return t(key, DONOR_THANKS_DEFAULTS[key]);
};
